import React from 'react'
import Select from 'lib/components/select'
import Toggle from '../../toggle'
import ChartMap from './chart-map'
import ChartSwitch from '../../chart-switch'
import withSend from 'microcosm/addons/with-send'
import RA from 'ra-config'

const horizontalDefaultList = {
  Exp5YREx: 'TrackingError',
  HistITDEx: 'TrackingError',
  Hist5YREx: 'TrackingError',
  Exp5YRReal: 'Vol',
  Exp5YRNom: 'Vol',
  HistITDReal: 'Vol',
  HistITDNom: 'Vol',
  Hist5YRReal: 'Vol',
  Hist5YRNom: 'Vol'
}

const {
  horizontalOptionList,
  verticalOptionList,
  verticalTypeOptionList
} = RA.app.strategies.chartConfig.scatterPlot

class StrategiesXYScatterPlot extends React.PureComponent {
  setXFilter = event => {
    this.props.send('patchQuery', {
      xAxis: event.target.value
    })
  }

  setYFilter = event => {
    const value = event.target.value

    this.props.send('patchQuery', {
      xAxis: horizontalDefaultList[value],
      yAxis: value
    })
  }

  setYAxisType = event => {
    this.props.send('patchQuery', {
      yAxisType: event.target.value
    })
  }

  getYAxisOptions() {
    return verticalOptionList.map(function({ text, prefix, suffix }) {
      return { text, value: prefix + suffix }
    })
  }

  getDefaultOptions() {
    const x = horizontalOptionList.find(o => o.default)
    const yOption = verticalOptionList.find(o => o.default)
    const yAxisType = verticalTypeOptionList.find(o => o.default).value
    const yAxis = yOption.prefix + yOption.suffix

    return {
      xAxis: x.value,
      yAxis: yAxis,
      yAxisType: yAxisType
    }
  }

  getOptions() {
    return Object.assign({}, this.getDefaultOptions(), this.props.query)
  }

  render() {
    const { data, title } = this.props

    const options = this.getOptions()

    return (
      <div className="chart-container">
        <form className="chart-container__menu -wide -scatterplot split-nav">
          <div className="split-nav__main">
            <div className="chart-selector">
              <Select
                label="Vertical"
                labelFor="scatter-y-category"
                onChange={this.setYFilter}
                options={this.getYAxisOptions()}
                selected={options.yAxis}
              />
            </div>

            <div className="chart-selector">
              <Select
                label="Horizontal"
                labelFor="scatter-x-category"
                onChange={this.setXFilter}
                options={horizontalOptionList}
                selected={options.xAxis}
              />
            </div>
          </div>

          <div className="split-nav__aux">
            <div className="chart-toggle">
              <Toggle
                label="Trading Costs"
                suffix="of trading costs"
                name="scatter-netgross"
                onChange={this.setYAxisType}
                options={verticalTypeOptionList}
                selected={options.yAxisType}
              />
            </div>
          </div>
        </form>

        <div className="chart-container__chart">
          <ChartSwitch
            title={title}
            chartMap={ChartMap}
            chart={{ text: 'Strategies' }}
            aggregate={data}
            query={options}
            focus={options.selected}
          />
        </div>
      </div>
    )
  }
}

export default withSend(StrategiesXYScatterPlot)



// WEBPACK FOOTER //
// ./src/components/strategies/charts/x-y-scatterplot.js